import React from 'react'
import axios from 'axios'
import './select-family-id-for-onboarding-card.css'
import { baseUrl } from '../../assets/Animations'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const SelectFamilyIdForOnboardingCard = ({selectFamilyToGetDistances, getTeacherDistanceSuggestions, setSelectFamilyToGetDistances, setOpenStudentOnboardingModal2023}) => {
    const [familySuggestions, setFamilySuggestions] = React.useState([])

    const selectTheFamily = (id) => {
        axios.put(`${baseUrl}/student-onboarding/changeId/${selectFamilyToGetDistances}`, {familyId: id}, myHeader)
        .then(res => {
            // setOpenStudentOnboardingModal from prevState
            setOpenStudentOnboardingModal2023(prevState => ({...prevState, familyId: id}))
            getTeacherDistanceSuggestions(res.data.familyId, res.data.whichSchool, res.data.todoId)
            setTimeout(() => {
                setSelectFamilyToGetDistances(false)
            }, 100)
        })
        .catch(err => {
            console.log(err)
        })
    }

    const getFamilySuggestions = (query) => {
        axios.get(`${baseUrl}/search/${query}`, myHeader)
        .then(res => {
            setFamilySuggestions(res.data)
        })
        .catch(err => {
            console.log(err)
        })
    }

    return (
        <div className="select-family-id-for-onboarding-card-popup">
            <div>Select the Family to get distance suggestions:</div>
            <input className='select-family-id-for-onboarding__search' type="text" onChange={(e) => {getFamilySuggestions(e.target.value)}}/>
            {familySuggestions.map((family, index) => (
                    <div className='select-family-id-for-onboarding__suggestion' key={index} onClick={() => {selectTheFamily(family.familyId)}}>{family.primaryParentName} {family.familyName} ({family.school})</div>
                )
            )}
        </div>
    )
}
export default SelectFamilyIdForOnboardingCard;